export const GET_PLAYER_WITHDRAWAL_LIST = 'GET_PLAYER_WITHDRAWAL_LIST';
export const GET_PLAYER_WITHDRAWAL_LIST_SUCCESS =
    'GET_PLAYER_WITHDRAWAL_LIST_SUCCESS';
export const GET_PLAYER_WITHDRAWAL_LIST_FAIL =
    'GET_PLAYER_WITHDRAWAL_LIST_FAIL';

export const RESET_PLAYER_WITHDRAWAL_ERRORS =
    'RESET_PLAYER_WITHDRAWAL_ERRORS';
